
import DashboardIcon from '@mui/icons-material/Dashboard';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import { moduleHeader, ROUTES } from "../Utils/routes";

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleIcon from '@mui/icons-material/People';

export const SidebarData = [
  {
    id: 1,
    title: moduleHeader[ROUTES.DASHBOARD],
    path: ROUTES.DASHBOARD,
    icon: DashboardIcon,
  },
  {
    id: 2,
    title: moduleHeader[ROUTES.PLAYERS],
    path: ROUTES.PLAYERS,
    icon: DirectionsRunIcon,
  },
  {
    id: 3,
    title: moduleHeader[ROUTES.COMMISSION],
    path: ROUTES.COMMISSION,
    icon: AttachMoneyIcon,
  },
  {
    id: 4,
    title: moduleHeader[ROUTES.USER_HOLDINGS],
    path: ROUTES.USER_HOLDINGS,
    icon: PeopleIcon,
  }
];